import ScrollTopButton from './scroll-top-button.component';

export default ScrollTopButton;
